import { Banner } from 'slab'
import { conditionallyLocalizeDate, dateFromISOString } from 'utils'

export const QleEarlySubmitBanner = ({ earliestTimeToSubmit }: { earliestTimeToSubmit: string }) => {
  if (!earliestTimeToSubmit) return null

  const formattedEarliestTimeToSubmit = conditionallyLocalizeDate(dateFromISOString(earliestTimeToSubmit))

  return (
    <Banner type='info' title={`Checkout is paused until ${formattedEarliestTimeToSubmit}`}>
      <p>You can only submit changes to your coverage once your qualifying event has happened.</p>
      <p>You're welcome to keep shopping around until then — we'll save any plan or dependent changes you add to your cart.</p>
    </Banner>
  )
}
